import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Loader2, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { productsAPI } from '../services/api';
import { useT } from '../services/i18n';

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');

// Account « Mes alertes » block: weekly new-arrivals e-mail subscriptions (per category)
const MyNewArrivalsSubs = () => {
  const { t } = useT();
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState('');
  useEffect(() => { productsAPI.mySubscriptions().then((d) => setItems(d.items)).catch(() => setItems([])); }, []);
  const remove = async (id) => {
    setBusy(id);
    try { await productsAPI.deleteSubscription(id); setItems((l) => l.filter((s) => s.id !== id)); toast.success(t('new.subRemoved')); } catch { toast.error(t('new.subError')); } finally { setBusy(''); }
  };
  if (!items) return <div className="flex justify-center py-6"><Loader2 className="animate-spin text-orange-500" size={20} /></div>;
  return (
    <section className="mt-8" data-testid="my-new-arrivals-subs">
      <h3 className="font-semibold text-gray-900 flex items-center gap-2 mb-1"><Sparkles size={18} className="text-orange-500" /> {t('new.subsTitle')} <span className="text-sm font-normal text-gray-500" data-testid="my-new-arrivals-subs-count">({items.length})</span></h3>
      <p className="text-xs text-gray-500 mb-3">{t('new.subsHint')}</p>
      {items.length === 0 ? (
        <p className="text-sm text-gray-500 border border-dashed rounded-lg p-4 text-center" data-testid="my-new-arrivals-subs-empty">{t('new.subsEmpty')} <Link to="/nouveautes" className="text-orange-600 underline">{t('new.title')}</Link></p>
      ) : (
        <ul className="space-y-2">
          {items.map((s) => (
            <li key={s.id} className="flex items-center justify-between gap-3 bg-white border rounded-lg px-4 py-2.5" data-testid={`my-new-arrivals-sub-${s.id}`}>
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">{s.category ? s.category_name || s.category : t('new.allCats')}</p>
                <p className="text-xs text-gray-500">{t('new.subsSince', { d: fmt(s.created_at) })}{s.last_sent_at ? ` · ${t('new.subsLast', { d: fmt(s.last_sent_at) })}` : ''}</p>
              </div>
              <button type="button" onClick={() => remove(s.id)} disabled={busy === s.id} className="text-xs text-gray-500 hover:text-red-600 inline-flex items-center gap-1" data-testid={`my-new-arrivals-sub-remove-${s.id}`}>{busy === s.id ? <Loader2 size={12} className="animate-spin" /> : <Trash2 size={12} />} {t('acc.remove')}</button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default MyNewArrivalsSubs;
